import { apiGet } from './client';
import type { ValuationParams } from '../types/ValuationParams';

// Tenant-scoped (rides on the X-Tenant-Id header the client injects) and NOT
// permission-gated server-side — the StatusFooter shows this to every user,
// including FundManagers who have no access to the day-open screen itself.
export function getValuationParams(): Promise<ValuationParams> {
  return apiGet<ValuationParams>('/api/valuation-params');
}
